var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6977 15.6C8.93047 13.5938 5 8.73125 5 6C5 2.68625 7.9101 0 11.5 0C15.0885 0 18 2.68625 18 6C18 8.73125 14.0391 13.5938 12.3023 15.6C11.8859 16.0781 11.1141 16.0781 10.6977 15.6ZM11.5 8C12.6951 8 13.6667 7.10312 13.6667 6C13.6667 4.89688 12.6951 4 11.5 4C10.3049 4 9.33333 4.89688 9.33333 6C9.33333 7.10312 10.3049 8 11.5 8Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23145 14.1206C9.04785 15.2424 9.81348 16.22 10.3965 16.9375C10.9365 17.6099 11.9385 17.6099 12.4785 16.9375C13.0469 16.2261 13.7998 15.2593 14.6064 14.1497C19.1807 14.5696 22.5 15.8252 22.5 17.3088C22.5 19.1362 17.4629 20.6177 11.25 20.6177C5.03711 20.6177 0 19.1362 0 17.3088C0 15.7891 3.48438 14.5085 8.23145 14.1206Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveMarker);
export default __webpack_public_path__ + "static/media/move-marker.23270c7d598c499b57b99a943921c4db.svg";
export { ForwardRef as ReactComponent };